import React from 'react';
import { CheckIcon } from 'lucide-react';
import { outcomes } from '../data/content';
import { RichText } from './RichText';
import { SectionHeading } from './SectionHeading';
export function Outcomes() {
  return <section className="px-5 pb-14 pt-8 sm:px-6 md:px-8" data-id="element-124" data-mp="1m9ukecfcaq6j">
      <div className="mx-auto max-w-[640px]" data-id="element-125" data-mp="1r7w1wsx4ahfw">
        <SectionHeading eyebrow="The result" data-id="element-126" data-mp="1r6l02yn8fjrf">
          What will you achieve with the Little Engineers collection?
        </SectionHeading>

        <ul className="mt-7 space-y-5" data-id="element-127" data-mp="tiaxahfmgrz9">
          {outcomes.map((line, index) => <li key={index} className="flex gap-3.5" data-id="element-128" data-mp="yh5oa6nqtmug" data-mpi={index}>
              <span className="mt-1 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-forest-600" aria-hidden="true" data-id="element-129" data-mp="13i1ooa8vyqv4">
                <CheckIcon className="h-3 w-3 text-white" strokeWidth={3} data-id="element-130" data-mp="au5xfl235r5q" />
              </span>
              <p className="text-[16.5px] leading-[1.65] text-ink-800" data-id="element-131" data-mp="fsh8fz44a7pj">
                <RichText line={line} data-id="element-132" data-mp="fqe7ik1feu61" />
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}